if (typeof extend != 'function') {
    function extend(Child, Parent) {
        var F = function () {
        };
        F.prototype = Parent.prototype;
        Child.prototype = new F();
        Child.prototype.constructor = Child;
        Child.superclass = Parent.prototype;
    }
}

if (typeof getInitial != 'function') {
    function getInitial(el, defName, eventTrigger, dataTrigger) {
        if (!(el instanceof jQuery)) {
            throw new Error("Invalid argument - is not jquery object");
        }
        if (typeof defName == 'undefined') {
            defName = 'initDeferred';
        }
        var defer = el.data(defName);
        if (!defer) {
            defer = $.Deferred();
            el.data(defName, defer);
        }
        el.on(eventTrigger, function () {
            defer.resolve();
        });
        if (el.data(dataTrigger)) {
            defer.resolve();
        }
        return defer;
    }
}
if (typeof lazyLoadReceived != 'function') {
    function lazyLoadReceived(fn, context) {
        if ($('.j-lazy-load').length > 0) {
            $(document).on("lazyLoadReceived", function () {
                return fn.apply(context || window);
            });
        } else {
            return fn.apply(context || window);
        }
    }
}

/**
 * Падежи для числа
 * Пример: 'Ещё ' + declOfNum(CNT, ['офис', 'офиса', 'офисов']);
 *
 *
 *
 * @param number
 * @param titles
 *
 * @return string
 */
function declOfNum(number, titles) {
    var cases = [2, 0, 1, 1, 1, 2];
    return '' + number + " " + titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[Math.min(number % 10, 5)]];
}

function ucwords(str) {
    return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
        return $1.toUpperCase();
    });
}

function array_chunk(input, size) {
    for (var x, i = 0, c = -1, l = input.length, n = []; i < l; i++) {
        (x = i % size) ? n[c][x] = input[i] : n[++c] = [input[i]];
    }
    return n;
}

/**
 * @requires - завязка на гео модуль ($geo->getRegionalMask), нужно добавить в тег body ата аттрибут phone-mask
 * @param input
 * @param par
 */

function maskedInput(input, par) {
    if (!window.disableMask) {
        // add phone mask
        if (input.length > 0) {
            require(['jquery', "maskedinput"], function ($) {
                if (window.maskVer == "2.1") {
                    applyMaskExtended(input, par);
                } else {
                    applyMaskSimple(input, par);
                }
            });
        }
    }
}

function applyMaskSimple(input, par) {

    if (typeof $.mask.definitions['d'] != 'string') {
        $.mask.definitions['d'] = '[0-9]';
        delete $.mask.definitions['9'];
    }

    if ($('body').data('phone-mask')) {
        endMask = $('body').data('phone-mask');
    } else {
        var arHost = location.host.split('.');
        var subDomain = arHost[0];
        var baseDomain = arHost[arHost.length - 1];

        if (subDomain == 'dubai' || $('body').data('countryCode') == 'uae') {
            endMask = "+971 ddddddddd";
        } else if (subDomain == 'montreal' || subDomain == 'toronto' || $('body').data('countryCode') == 'canada') {
            endMask = "+1 ddd ddd - dddd";
        } else if (baseDomain == 'ua' || $('body').data('countryCode') == 'ua') {
            endMask = "+38 (ddd) ddd-dddd";
        } else {
            endMask = '+7 (ddd) ddd-dddd';
        }
    }
    input.mask(endMask, par);
}


function applyMaskExtended(input, par) {
    var glSettings = [];
    $.jMaskGlobals.watchInputs = false;
    var flag = (typeof $(input).parents('form').data('flag') == 'undefined') ? false :  $(input).parents('form').data('flag');
    if (window.flagPhone !== true)
        flag = false;
    /**
     * Определяет домен, поддомен, маску и префикс.
     * @returns {} - возвращает объект
     *         result.host - ссылка;
     *         result.domain - основной домен;
     *         result.subdomain - поддомен;
     *         result.mask - маска;
     *         result.prefix - префикс;
     */
    function getDomain() {
        var arHost = location.host.split('.');
        var subDomain = arHost[0];
        var baseDomain = arHost[arHost.length - 1];
        var endMask = "";
        var prefix;
        var result = {};
        var country = 'ru';

        if ($('body').data('phone-mask')) {
            endMask = $('body').data('phone-mask');
        } else {
            if (subDomain == 'dubai' || $('body').data('countryCode') == 'uae') {
                endMask = "+971 ddddddddd";
                country = 'ae';
            } else if (subDomain == 'montreal' || subDomain == 'toronto' || $('body').data('countryCode') == 'canada') {
                endMask = "+1 ddd ddd - dddd";
                country = 'ca';
            } else if (baseDomain == 'ua' || $('body').data('countryCode') == 'ua') {
                endMask = "+38 (ddd) ddd-dddd";
                country = 'ua';
            } else if (baseDomain == 'kz' || $('body').data('countryCode') == 'kazakhstan') {
                endMask = "+7 (ddd) ddd-dddd";
                country = 'kz';
            } else if (baseDomain == 'by') {
                endMask = "+375 (ddd) ddd-dddd";
                country = 'by';
            } else {
                endMask = '+7 (ddd) ddd-dddd';
            }
        }

        prefix = endMask.substring(0, endMask.indexOf("d"));
        result.domain = baseDomain;
        result.subdomain = subDomain;
        result.mask = endMask;
        result.prefix = prefix;
        result.country = country;
        return result;
    }

    /**
     * Добавляет tooltipster
     * @returns {boolean} (true|false)
     */
    function enableTooltipster() {
        var $context = input["context"]; //Контекст вызова
        var $currentInput = $(input, $context); //Текущий элемент в контексте
        var $currentParent = $currentInput.closest('.text', $context);
        var $maskhelper = $currentParent.find('.maskhelper');

        if (!$maskhelper.length) {
            $currentParent.append("<span class='maskhelper' title='Очистить формат телефoна'></span>");
            $maskhelper = $currentParent.find('.maskhelper'); //Снова ищем тултипстер

            //А вот тут активируем
            require(['tooltipster'], function () {
                $maskhelper.tooltipster({
                    theme: ['tooltipster-light', 'tooltipster-light-customized'],
                    contentCloning: true,
                    maxWidth: 250,

                    functionInit: function (origin, content) {
                        var $form = origin._$origin.closest('form');
                        var tooltipsterArea = origin._$origin.closest('.tooltipster-area');
                        var $boxForm = tooltipsterArea.length>0 ? tooltipsterArea : $form;

                        if ($boxForm.length) {
                            $boxForm.on('mouseleave', function (event) {
                                event.preventDefault();
                                $boxForm.find('.maskhelper').tooltipster('close');
                            });
                        }
                    },

                    functionReady: function (instance, helper) {
                        var $form = instance._$origin.closest('form');

                        if ($form.length) {
                            $(document).on('scroll, touchmove', function (event) {
                                event.preventDefault();
                                $form.find('.maskhelper').tooltipster('close');
                            });

                            $(document).on('click', function (event) {
                                if(!$(event.target).closest('.iti__country-list').length)
                                    $form.find('.maskhelper').tooltipster('close');
                            })
                        }
                    }


                });
            });

        }
        return true;
    }

    /**
     * Проверяет, есть ли обработчик очистки на кнопке maskhelper. Если нет — назначает
     * @param input
     */

    function clearField(input) {
        var $parents = $(input).closest('.text');
        var $context = input["context"]; //Контекст вызова
        var $maskhelper = $parents.find('.maskhelper');
        var clicks = ('click' in $._data($maskhelper[0], "events"));
        var currentInput = $parents.find('input');

        var endMask = currentInput.data('mask').mask;
        var prefix = endMask.substring(0, endMask.indexOf("0"));

        if (!clicks) {
            $maskhelper.on('click', function (event) {
                event.preventDefault();
                endMask = currentInput.data('mask').mask;
                prefix = endMask.substring(0, endMask.indexOf("0"));
                currentInput.val(prefix);
                $(this).tooltipster('content', 'Очищено');
                $(this).tooltipster('open');

            });
        }
        $maskhelper.removeClass('overload').tooltipster('content', 'Очистить');
    }

    /**
     * Устанавливает маску на поля. Маска не очищена
     * @param input - текущее поле ввода.
     */
    function setMask(input, opt) {
        var settings = getDomain();
        var $context = input["context"]; //Контекст вызова
        var $currentInput = $(input, $context); //Текущий элемент в контексте
        var $currentParent = $currentInput.closest('.text', $context);
        glSettings['country'] = settings['country'];

        if(typeof opt !== 'undefined') {
            settings["mask"] = opt.mask;
            settings["prefix"] = opt.prefix;
        }


        var endMask = settings["mask"];
        var prefix = settings["prefix"];
        var valueMaxLength = endMask.replace(/[-\/\\^$*+?.()|[\]{}\s]/g, '');//Убирает все лишние масочные символы, оставляет только префикс и символы маски

        var extendedMaskBehaviour = function (val) {
            var subDomain = settings['subdomain'];
            var valueMaxLength = settings["mask"].replace(/[-\/\\^$*+?.()|[\]{}\s]/g, '').length;
            var endMask = settings["mask"].replace(/d/g, "0");
            var endMaskWhide = (settings["mask"] + 'dd').replace(/d/g, "0");
            val = val || "";
            return (val.replace(/\D/g, '').length >= valueMaxLength) ? endMaskWhide : endMask; //Здесь подменяем маску
        };


        var extendedOptions = { //здесь указываем опции маски
            placeholder: endMask.replace(/d/g, "_"),
            translation: {
                d: {pattern: /[0-9]/},
            },
            onKeyPress: function (val, e, field, options) {
                field.mask(extendedMaskBehaviour.apply({}, arguments), options);
            }
        };

        //Выдернули маску и префикс
        if (endMask.length && prefix.length) {
            $currentInput.on('keyup', {el:$currentInput, maxLen:valueMaxLength}, eventKeyUp);

            $currentInput.mask(extendedMaskBehaviour, extendedOptions);
        }

    }

    /**
     * Фунекция обработки ввода с клавиатуры
     * @param event - объект события из setMask
     */
    function eventKeyUp(event) {
        event.preventDefault();
        var el = event.data.el;
        var valueMaxLength = event.data.maxLen;

        checkTooltipsterLength(el, valueMaxLength);
    }


    /**
     * Функция установки облака tooltipster
     *
     */
    function checkTooltipsterLength(el, valueMaxLength) {
        var parent = $(el).closest('.text');
        var currentValueLength = $(el).val().replace(/\D/g, '').length;
        var $maskhelper = $(el).closest('.text').find('.maskhelper');
        $maskhelper.tooltipster('close');
        var hardClearMask = $('body').data('hard-clear-mask');
        if (hardClearMask == "Y") {
            if (currentValueLength >= valueMaxLength.length) { //равно — все ок
                $(parent).removeClass('error');
                $(parent).removeClass('not-success');
            }
        }
        else {
            if (currentValueLength > valueMaxLength.length) { //больше: ставим алерт и меняем иконку. Убираем обработчики кнопки, если есть.
                $maskhelper.tooltipster('content', 'Вы пытаетесь ввести больше ' + valueMaxLength.length + ' символов, проверьте номер телефона или введите в произвольном формате');
                $maskhelper.addClass('overload').tooltipster('open');
                $maskhelper.off("click");
                clearTimeout(window.timerPhone);
                window.timerPhone = window.setTimeout(function () {
                    $maskhelper.tooltipster('close');
                }, 4000);
                $(parent).addClass('error');
                $(parent).addClass('not-success');
            }

            if (currentValueLength === valueMaxLength.length) { //равно — все ок
                clearField($(el));
                $(parent).removeClass('error');
                $(parent).removeClass('not-success');
            }

            if (currentValueLength < valueMaxLength.length) { //меньше: назначаем обработчик, если его нет
                clearField($(el));
                $(parent).addClass('error');
            }
        }
    }

    /**
     * Устанавливает первоначальную очистку маски.
     * @param input
     */

    function clearMask(input) {
        var $context = input["context"]; //Контекст вызова
        var $currentInput = $(input, $context); //Текущий элемент в контексте
        var $parents = $currentInput.closest('.text', $context);
        var $maskhelper = $parents.find('.maskhelper', $context).not('.overload');

        var endMask = $currentInput.data('mask').mask;
        var prefix = endMask.substring(0, endMask.indexOf("d"));
        var hardClearMask = $('body').data('hard-clear-mask');

        if(hardClearMask == "Y"){
            $( ".maskhelper" ).mouseenter(function(){
                $parents.removeClass('error');
            });
        }

        $maskhelper.on('click', function (event) {
            if(hardClearMask == "Y"){
                input.unmask();
                $currentInput.attr("data-hard-clear-mask","Y");
                $parents.removeClass('error');
                $currentInput.addClass('field-phone-number');
                $currentInput.attr('maxlength','13');
            }
            event.preventDefault();
            var $button = $(this);
            if (!$button.is('.overload')) {
                $currentInput.val(prefix);
                $(this).tooltipster('content', 'Очищено');
                $(this).tooltipster('open');
            }
        });
    }

    /**
     * Фокус на текущем поле. Ставит префикс по умолчанию
     * @param input
     */
    function focusField(input) {
        var $context = input["context"]; //Контекст вызова
        var $currentInput = $(input, $context); //Текущий элемент в контексте

        var endMask = $currentInput.data('mask').mask;

        $currentInput.on('focus', function (event) {
            event.preventDefault();
            var prefix = endMask.substring(0, endMask.indexOf("d"));
            var value = $(this).val();
            if (value <= prefix) {
                $(this).val(prefix);
            }
        });
    }

    /**
     * Инициализируем иконку флага на поле
     * @param input
     */
    function initFlagPhone(input) {
        if(flag) {
            require(['flagTelephone'], function () {

                var $context = input["context"]; //Контекст вызова
                var $currentInput = $(input, $context); //Текущий элемент в контексте
                var objMask = $currentInput.data('mask').mask;
                var country = glSettings['country'];
                var wrap = $currentInput.closest('.text');
                var iti;


                if(objMask) {
                    window.intlTelInputGlobals.loadUtils('/bitrix/templates/main/vendor/intltelinput/js/utils.js');
                    country = $('body').data('phone-mask-cc');
                    iti = window.intlTelInput(
                        input[0],
                        {
                            autoPlaceholder: 'off',
                            autoHideDialCode: false,
                            nationalMode: false,
                            initialCountry: country,
                            preferredCountries: ['ru', 'by', 'kz'],
                        });
                }

                $(input[0]).off('countrychange').on('countrychange', function(e) {
                    var numberType = window.intlTelInputUtils.numberType[iti.options.placeholderNumberType];
                    var maskUtils = iti.selectedCountryData.iso2 ? intlTelInputUtils.getExampleNumber(iti.selectedCountryData.iso2, iti.options.nationalMode, numberType) : "";

                    var maskBeforeUtils = maskUtils.split(' ')[0];
                    var maskAfterUtils = maskUtils.replace(maskBeforeUtils, '');
                    var maskResultUtils = maskAfterUtils.replace(/[0-9]/g, "d");
                    var newDomainOptions = {
                        prefix: '+'+iti.getSelectedCountryData().dialCode+' (',
                        mask: '+'+iti.getSelectedCountryData().dialCode+maskResultUtils
                    };

                    $currentInput.data('mask').mask = newDomainOptions.mask;
                    $currentInput.data('mask').options.placeholder = newDomainOptions.mask.replace(/d/g, "_"); ///[0-9 -()+]+$/

                    wrap.attr('data-mask', newDomainOptions.mask);

                    removeMask(input);
                    setMask(input, newDomainOptions); // Ставим маску
                    setStart(input);
                    checkTooltipsterLength(input, newDomainOptions.mask.replace(/[-\/\\^$*+?.()|[\]{}\s]/g, ''));
                });
            });
        }
    }

    /**
     * Блюр с текущего поля. Чистит его.
     * @param input
     */
    function blurField(input) {
        var $context = input["context"]; //Контекст вызова
        var $currentInput = $(input, $context); //Текущий элемент в контексте
        var $parents = $currentInput.closest('.text', $context);

        var endMask = $currentInput.data('mask').mask;

        $currentInput.on('blur', function (event) {
            event.preventDefault();
            var prefix = endMask.substring(0, endMask.indexOf("d"));
            var value = $(this).val();
            // $parents.removeClass('error').removeClass('valid');

            if (value <= prefix) {
                $(this).val('');
            }
        });
    }

    /**
     * Устанавливает курсор в нужную позицию
     * @param input - текущее поле
     * @param pos - позиция
     */
    function setCursorPosition(input, pos) {
        if ($(input).get(0).setSelectionRange) {
            $(input).get(0).setSelectionRange(pos, pos);
        } else if ($(input).get(0).createTextRange) {
            var range = $(this).get(0).createTextRange();
            range.collapse(true);
            range.moveEnd('character', pos);
            range.moveStart('character', pos);
            range.select();
        }
    };


    function setStart(input) {
        var $context = input["context"]; //Контекст вызова
        var $currentInput = $(input, $context); //Текущий элемент в контексте

        $currentInput.on('click', function (event) {
            event.preventDefault();
            var startPosition = $(this).val().length;
            setCursorPosition($(this), startPosition);
        });
    }

    function removeMask(input) {
        var $context = input["context"]; //Контекст вызова
        var $currentInput = $(input, $context); //Текущий элемент в контексте
        $currentInput.off('keyup', eventKeyUp);

    }

    if (enableTooltipster()) { //Проверяем тултипстер
        if(input.length > 1) {
            input.each(function (inp) {
                setMask($(input[inp])); // Ставим маску
                clearMask($(input[inp])); //Первоначальная очистка
                focusField($(input[inp])); //Фокус на поле
                blurField($(input[inp])); //Блюр с поля
                setStart($(input[inp])); //Переносим курсор в конец номера
                initFlagPhone($(input[inp]));
            });
        }
    else {
            setMask(input); // Ставим маску
            clearMask(input); //Первоначальная очистка
            focusField(input); //Фокус на поле
            blurField(input); //Блюр с поля
            setStart(input); //Переносим курсор в конец номера
            initFlagPhone(input);
        }
    }
}

/**
 * подготавливаем строку для конвертации в регулярку
 * @param string like phone number +973-dddd-dddd
 * @returns {void | string | never | *}
 */
RegExp.escape = function (string) {
    string = string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    return string.replace(new RegExp('d', 'g'), '\\d');
};
/**
 * тултипсы, срабатывают для элементов у которых есть дата аттрибут tooltip
 * используется например для подсказки маски телефона в формах
 */
var showingTooltip;

document.onmouseover = function (e) {
    var target = e.target;

    var tooltip = target.getAttribute('data-tooltip');
    if (!tooltip) return;

    var tooltipElem = document.createElement('div');

    if (target.className != 'maskhelper green') {
        tooltipElem.className = 'inf-tooltip';
    } else {
        tooltipElem.className = 'inf-tooltip green';
    }

    tooltipElem.innerHTML = tooltip;
    document.body.appendChild(tooltipElem);

    var coords = target.getBoundingClientRect();

    var left = coords.left + (target.offsetWidth - tooltipElem.offsetWidth) / 2;
    if (left < 0) left = 0; // не вылезать за левую границу окна

    var top = coords.top - tooltipElem.offsetHeight - 5;
    if (top < 0) { // не вылезать за верхнюю границу окна
        top = coords.top + target.offsetHeight + 5;
    }

    tooltipElem.style.left = left + 'px';
    tooltipElem.style.top = top + 'px';

    showingTooltip = tooltipElem;
};

document.onmouseout = function (e) {
    hideTooltip();
};

document.onscroll = function (e) {
    hideTooltip();
};

document.ontouchmove = function (e) {
    hideTooltip();
};

/*end tooltips*/
function hideTooltip() {
    if (showingTooltip) {
        document.body.removeChild(showingTooltip);
        showingTooltip = null;
    }
}

function dataString2Json(data) {
    if (typeof data == 'string') {
        return BX.parseJSON(data);
    }
    return data;
}

function count(obj) {
    var cnt = 0;
    for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
            cnt++;
        }
    }
    return cnt;
}

function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
        selector = $this.attr('href')
        selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
}

function findParentClass(obj, className) {
    if (obj.constructor.name == className) {
        return obj;
    } else {
        return findParentClass(obj.constructor.superclass, className);
    }
}

function findItem(items, id, callable) {
    for (var i in items) {
        var item = items[i];
        if (typeof callable == 'function' && callable(item, id) || item['ID'] == id) {
            return item;
        }
    }
    return false;
}

function deleteItem(items, id, callable) {
    for (var i in items) {
        var obItem = items[i];
        if (typeof callable == 'function' && callable(obItem, id) || obItem['ID'] == id) {
            return items.splice(i, 1)[0];
        }
    }
}

if (typeof remove != 'function') {
    function remove(arr, item, callable) {
        for (var i = arr.length; i--;) {
            if (typeof callable == 'function' && callable(arr[i], i) || arr[i] === item) {
                arr.splice(i, 1);
            }
        }
    }
}

function deepEqual(a, b) {
    if (a === b) {
        return true;
    }

    if (a == null || typeof (a) != "object" ||
        b == null || typeof (b) != "object") {
        return false;
    }

    var propertiesInA = 0, propertiesInB = 0;
    for (var property in a) {
        propertiesInA += 1;
    }
    for (var property in b) {
        propertiesInB += 1;
        if (!(property in a) || !deepEqual(a[property], b[property])) {
            return false;
        }
    }
    return propertiesInA == propertiesInB;
}

function dayDiff(first, second) {
    return (second - first) / (1000 * 60 * 60 * 24);
}

/**
 * Форматирование размера файла
 *
 * @param bytes
 *
 * @return string
 */
function byteConvert(bytes) {
    var symbol = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var exp = Math.floor(Math.log(bytes) / Math.log(1024));
    var result = (bytes / Math.pow(1024, exp)).toFixed(2);
    var resultStr = result + ' ' + symbol[exp];

    return resultStr;
}

if (typeof window.track != 'function') {
    window.track = function (p) {
        return true;
    }
}
if (typeof window.trackStep != 'function') {
    window.trackStep = function (path) {
        return true;
    }
}

/**
 * Форматирование размера файла
 *
 * @param parameter, defaultvalue
 *
 * @return string
 */
function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
}

function getUrlParam(parameter, defaultvalue) {
    var urlparameter = defaultvalue;
    if (window.location.href.indexOf(parameter) > -1) {
        urlparameter = getUrlVars()[parameter];
    }
    return urlparameter;
}
var hardClearMask = $('body').data('hard-clear-mask');
if (hardClearMask == "Y") {
    $(".form-control").keypress(function () {
        if ($(this).val().length == $(this).attr("maxlength")) {
            return false;
        }
    });
}
$('body').on('input', '.field-phone-number', function(){
    this.value = this.value.replace(/[^0-9]/g, '');
});

define("tools/tools", function(){});

